import { ref } from "vue"
import type { Router } from "vue-router"

const HOME_PATH = "/dashboard"
// Pages that make no sense to "return to" from home: login/entry flow and the debug window.
const IGNORED_PATHS = [/^\/$/, /^\/auth(\/|$)/, /^\/debug(\/|$)/, /^\/dashboard(\/|$)/]

// Module-level singleton (same pattern as `useChatStyle`/`useGroupDialog`): the page the user was on
// right before arriving home, so the mobile bottom nav can offer a one-tap way back to it. Tracked
// router-wide (see plugins/last-page.client.ts) rather than by the nav itself — the nav is remounted
// per page and isn't rendered at all on group/chat pages, which are exactly the ones worth returning to.
const lastPage = ref<string | null>(null)

export function trackLastPage(router: Router) {
  router.afterEach((to, from, failure) => {
    if (failure) return
    if (to.path !== HOME_PATH || from.path === HOME_PATH) return
    if (!from.matched.length || IGNORED_PATHS.some((re) => re.test(from.path))) return
    lastPage.value = from.fullPath
  })
}

/** Logout: the previous account's page means nothing to the next one. */
export function resetLastPage() {
  lastPage.value = null
}

export function useLastPage() {
  return { lastPage }
}
